export default "__VITE_ASSET__CwLsqE7g__"